import FirstSectionLiveArena251 from '../sections/FirstSectionLiveArena251';
import VideoSectionLiveRevalida251 from '../sections/VideoSectionLiveRevalida251';
import OtherProductsComponent from '../../../LDL/components/OtherProductsComponent';
import OtherProductsSection from '../sections/OtherProductsSection';

export default function PageLiveDoArena251() {
	return (
		<>
			<FirstSectionLiveArena251 />
			<VideoSectionLiveRevalida251 />
			<OtherProductsSection />
		</>
	);
}
